import { useQuery } from '@tanstack/react-query';

import { awaitJSON, MiscLambdaFetch } from '../../utils/fetch-utils';

const RUNNING_STATUSES: Record<string, boolean> = {
  SUBMITTED: true,
  PENDING: true,
  RUNNABLE: true,
  STARTING: true,
  RUNNING: true
};

export interface FailureRow {
  company: string;
  kpi: string;
  task: string;
  job_name: string;
  job_id: string;
  log_url: string;
  status: string;
  created: string;
  lastmodified: string;
  investigator: string | null;
  investigation_time: string | null;
  investigation_notes: string | null;
  expected_job_completion: string | null;
  builds: FailureRow[];
  running: boolean;
  agency: string;
  restarting?: boolean;
}

export const BATCH_FAILURES_QUERY_KEY = ['batchFailures'];

export const useBatchFailures = (): ReturnType<typeof useQuery<FailureRow[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: BATCH_FAILURES_QUERY_KEY,
    queryFn: async (): Promise<FailureRow[]> => {
      const data = await awaitJSON<FailureRow[]>(await MiscLambdaFetch('/get_batch_failures'));
      return data.map(row => ({ ...row, running: row.status in RUNNING_STATUSES }));
    }
  });
